import {reject, find, createSelector, createStructuredSelector} from 'helpers';

const files = createSelector(
  state => state.exported.files,
  files => reject([...files].reverse(), file => /\.zip$/.test(file.name))
    .map(file => ({
      ...file,
      zip: find(files, { name: file.name + '.zip' }),
    }))
);

export const data = createStructuredSelector({
  status: state => state.exported.status,
  files,
});

